var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4179 13.0007L11.8823 8.00065M7.12035 8.00065L1.58466 13.0007M1.16797 3.83398L7.97207 8.59685C8.52304 8.98254 8.79853 9.17538 9.09819 9.25007C9.36288 9.31605 9.63972 9.31605 9.90442 9.25007C10.2041 9.17538 10.4796 8.98254 11.0305 8.59685L17.8346 3.83398M5.16797 14.6673H13.8346C15.2348 14.6673 15.9348 14.6673 16.4696 14.3948C16.94 14.1552 17.3225 13.7727 17.5622 13.3023C17.8346 12.7675 17.8346 12.0674 17.8346 10.6673V5.33398C17.8346 3.93385 17.8346 3.23379 17.5622 2.69901C17.3225 2.2286 16.94 1.84615 16.4696 1.60647C15.9348 1.33398 15.2348 1.33398 13.8346 1.33398H5.16797C3.76784 1.33398 3.06777 1.33398 2.53299 1.60647C2.06259 1.84615 1.68014 2.2286 1.44045 2.69901C1.16797 3.23379 1.16797 3.93385 1.16797 5.33398V10.6673C1.16797 12.0674 1.16797 12.7675 1.44045 13.3023C1.68014 13.7727 2.06259 14.1552 2.53299 14.3948C3.06777 14.6673 3.76784 14.6673 5.16797 14.6673Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a52242db997ee63dea35e0b7c71b8ac0.svg";
export { ForwardRef as ReactComponent };